import { render, staticRenderFns } from "./rectangle_tool.vue?vue&type=template&id=0417e62d"
import script from "./rectangle_tool.vue?vue&type=script&lang=js"
export * from "./rectangle_tool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports